// extracted by mini-css-extract-plugin
export var chevronIcon = "_az-2";
export var teamName = "_az-1";
export var teamSwitcherButton = "_az-0";